import type { DashboardVM } from '../../lib/compute';

export function Kanaele({ vm }: { vm: DashboardVM }) {
  return (
    <>
      <div className="cw-pagehead">
        <h1>Kanäle</h1>
        <span className="meta">Umsatz je Verkaufskanal · {vm.rangeCaption}</span>
      </div>

      <div className="cw-chan-grid">
        {vm.channelsDetail.map((c) => (
          <section key={c.name} className="cw-card" style={{ padding: '20px 22px' }}>
            <div className="cw-cd-head">
              <div className="cw-cd-name">
                <span className="dot" style={{ background: c.color }} />
                <span className="nm">{c.name}</span>
              </div>
              <span className="cw-cd-share cw-num">{c.sharePct} Umsatzanteil</span>
            </div>
            <div className="cw-cd-figure">
              <span className="v cw-num">{c.umsatz}</span>
              {c.neu && <span className="t" style={{ color: '#8a8f94' }}>neu · in Aufbau</span>}
            </div>
            <svg viewBox="0 0 120 34" preserveAspectRatio="none" className="cw-cd-spark">
              <polyline points={c.spark} fill="none" stroke={c.color} strokeWidth="2" vectorEffect="non-scaling-stroke" strokeLinejoin="round" strokeLinecap="round" />
            </svg>
            <div className="cw-cd-stats" style={{ gridTemplateColumns: '1fr 1fr 1fr' }}>
              <div className="cw-stat"><span className="k">Bestellungen</span><span className="v cw-num">{c.orders}</span></div>
              <div className="cw-stat"><span className="k">Ø Warenkorb</span><span className="v cw-num">{c.aov}</span></div>
              <div className="cw-stat"><span className="k">Umsatzanteil</span><span className="v cw-num">{c.sharePct}</span></div>
            </div>
          </section>
        ))}
      </div>

      <div className="cw-sources">ROAS wird länderbasiert ausgewiesen (Tab „Werbung"), da Werbekosten je Land — nicht je Kanal — anfallen. · {vm.sources}</div>
    </>
  );
}
